 (function () {
        function ZendeskCustomWidget() {
         
            this.element = document.getElementById('zendesk-widget-custom');
 console.log("running"+this.element);
            this.options = localStorage['ZD-store'] ? JSON.parse(localStorage['ZD-store']) : {
                widgetShown: false,
                is_chatting: false
            };

            this.options.locked = false;

            if (this.element) {
                this.options.language = this.element.dataset.language;
                this.options.key = this.element.dataset.key;
            }
        }

        ZendeskCustomWidget.prototype.hideCustomWidget = function () {
            this.element.style.display = 'none';
        };

        ZendeskCustomWidget.prototype.showLoader = function () {
            this.element.querySelector('div.zd-icon-loader').style.display = 'inline-block';
            this.element.querySelector('div.zd-icon-default').style.display = 'none';
        };

        ZendeskCustomWidget.prototype.waitForLoad = function(mutationsList, observer) {
            for(var mutation of mutationsList) {
                if (mutation.attributeName === 'class') {
                    if(mutation.target.classList.contains('zEWidget-webWidget--active')) {
                        this.hideCustomWidget();
                        observer.disconnect();
                    }
                }
            }
        };

        ZendeskCustomWidget.prototype.onWidgetOpen = function () {
            var iframe = document.getElementById('webWidget');

            if(typeof MutationObserver === 'function' && iframe) {
                var observer = new MutationObserver(this.waitForLoad.bind(this));
                observer.observe(iframe, { attributes: true, childList: false, subtree: false });
            } else {
                this.hideCustomWidget();
            }
        };

        ZendeskCustomWidget.prototype.loadWidget = function (userInitiated) {
            var g = document.createElement('script');
            var s = document.getElementsByTagName('script')[0];

            g.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + this.options.key;
            g.async = true;
            g.id = 'ze-snippet';
            s.parentNode.insertBefore(g, s);

            g.onload = function () {
                zE('webWidget', 'setLocale', this.options.language);

                if (userInitiated) {
                    zE('webWidget', 'open');
                    zE('webWidget:on', 'open', this.onWidgetOpen.bind(this));
                }
            }.bind(this);
        };

        ZendeskCustomWidget.prototype.onClick = function (event) {
            event.preventDefault();

            if (this.options.locked) {
                return;
            }

            this.options.locked = true;

            this.showLoader();
            this.loadWidget(true);
        };

        var zendesk = new ZendeskCustomWidget();
        if (!zendesk.element) {
            return;
        }

        if (zendesk.options.widgetShown || zendesk.options.is_chatting) {
            zendesk.hideCustomWidget();
            zendesk.loadWidget(false);
            return;
        }

        zendesk.element.addEventListener('click', zendesk.onClick.bind(zendesk));
    })();